import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Form, Formik } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';
import { TextField } from '../../../../components/TextField';
import { FormActions, List, ListItem, type OnSubmit } from '../../../../design-system';
import { createSchema } from '../../../../utils/formUtils';

type MfaCode = { code: string };

const validationSchema = createSchema<MfaCode>({
  code: Yup.string()
    .required()
    .min(6, 'Code must be six characters')
    .max(6, 'Code must be six characters')
    .matches(/^\d+$/, 'Code must only include numbers'),
});

export interface SubmitCodeFormProps {
  onSubmit: OnSubmit<MfaCode>;
}

export const SubmitCodeForm: React.FC<SubmitCodeFormProps> = ({ onSubmit }) => (
  <Formik<MfaCode> initialValues={{ code: '' }} validationSchema={validationSchema} onSubmit={onSubmit}>
    {({ isSubmitting, values, touched, handleChange, errors }) => (
      <>
        <Form>
          <List>
            <ListItem>
              <TextField
                autoComplete="off"
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code ? errors.code : 'Enter the code from your MFA device '}
                id="code"
                inputElementProps={{ maxLength: 6 }}
                onChange={handleChange}
                size="medium"
                value={values.code}
              />
            </ListItem>
          </List>

          <FormActions>
            <Button color="primary" disabled={isSubmitting} type="submit" variant="contained">
              {isSubmitting ? <CircularProgress size={24} color="inherit" /> : 'Verify'}
            </Button>
          </FormActions>
        </Form>
      </>
    )}
  </Formik>
);
